import React from 'react';
import { TextField, withStyles } from '@material-ui/core';

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'black',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'black',
    },
  },
})(TextField);

interface EntryTextFieldProp {
  name: string;
  label: string;
  description?: string;
  placeholder?: string;
  errors?: any;
  required?: boolean;
  pattern?: RegExp;
  patternError?: string;
  register: (rules: any) => any;
  value?: any;
  visible?: boolean;
  rows?: number;
}
export default function EntryTextField({
  name,
  label,
  description,
  placeholder,
  errors = [],
  required = false,
  pattern,
  patternError,
  register,
  value,
  visible = true,
  rows = 1,
}: EntryTextFieldProp) {
  return visible && (
    <>
      <CssTextField className="entry-field entry-text"
        id={name}
        name={name}
        label={label}
        helperText={description}
        placeholder={placeholder}
        FormHelperTextProps={{className:"description"}}
        inputRef={register({ required, pattern })}
        InputLabelProps={{variant:'standard'}}
        {...{
          rows,
          multiline: rows! > 1,
        }}
        defaultValue={value}
      />
      {errors[name] && errors[name].type === 'required' && (
        <span className="entry-field-error">{`${label}を入力してください`}</span>
      )}
      {errors[name] && errors[name].type === 'pattern' && (
        <span className="entry-field-error">{patternError}</span>
      )}
    </>
  );
}